import { TMessageSchema, IMessageItem, IParsedMessage, TMessagesMap } from '../../types/messages';
import { updateMessageFromRaw } from './updateMessageFromRaw';

interface IUpdateExistingMessageParams {
  messageItem: IMessageItem;
  rawMessage: TMessageSchema;
  messagesMap: TMessagesMap;
}

/** Обновляет существующее сообщение данными из rawMessage и возвращает его. */
export function updateExistingMessage({
  messageItem,
  rawMessage,
  messagesMap,
}: IUpdateExistingMessageParams): IParsedMessage {
  const { message, messageIndex } = messageItem;

  // Обновляем существующее сообщение данными из rawMessage
  const parsedMessage: IParsedMessage = {
    ...message,
    rawMessage,
    message: updateMessageFromRaw({ existingMessage: message.message, rawMessage }),
  };

  messagesMap.set(rawMessage.messageId, {
    message: parsedMessage,
    messageIndex,
  });

  return parsedMessage;
}
